/*
 * tabList Tab页展示页签
 * operate 操作按钮
 * disabledProblemDetailTab 禁用问题tab页表单
 * enableProblemDetailTabFormItem 启用问题tab页表单项
 * disabledEmergencyMeasureTab 禁用应急措施tab页表单
 * enableEmergencyMeasureTabFormItem 启用应急措施tab页表单项
 * showEmergencyMeasureTabFormItem 显示应急措施tab页表单项
 * enableRootCauseAnalysisTabFormItem 启用根因分析tab页表单项
 * showRootCauseAnalysisTabFormItem 显示根因分析tab页表单项
 * enablePermanentProjectTabFormItem 启用永久方案tab页表单项
 * showPermanentProjectTabFormItem 显示永久方案tab页表单项
 */
export const taskIdData = {
  /*
   * 类型一，二，三公共节点
   */
  // 待重新提交（服务经理 -> 客户） | 质量反馈创建页面
  Activity_0ss6860: {
    taskName: "待重新提交",
    recordName: "提交反馈",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: ["marketLanguageShow"],
  },
  // 问题审核（经销商 -> 服务经理）
  Activity_00011zf: {
    taskName: "问题审核",
    recordName: "审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [
      "importantType",
      "importantDescribe",
      "carTotal",
      "happenDate",
      "faultType",
      "faultDescription",
      "marketService",
      "marketServiceResult",
      "faultPartNumber",
      "faultPartName",
      "customerDemand",
      "faultVideo",
      "faultVideoList",
      "faultCode",
      "faultCodeList",
      "otherInstructions",
      "faultOtherInstructionsList",
      "faultList",
      "repairPlan",
    ],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: [],
  },
  // 问题判定（服务经理 -> 技术经理）
  Activity_technical: {
    taskName: "问题判定",
    recordName: "问题判定",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: [
      "类型判定驳回",
      "已有解决方案",
      "类型1",
      "类型2",
      "类型3",
      "返回列表",
    ],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: ["importantType", "importantDescribe"],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: [
      "emergencyMeasureShow",
      "marketLanguageShow",
    ],
  },
  /*
   * 类型二，三公共节点
   */
  // 问题指派 (技术经理 -> 质量改善部A)
  Activity_1a4kvt8: {
    taskName: "问题指派",
    recordName: "指派",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["指派B", "类型三重新判定类型驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
  },
  /*
   * 类型二节点
   */
  // 应急措施 (质量改善部A -> 质量改善部B)
  Activity_1oawr6n: {
    taskName: "问题审核",
    recordName: "审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      // { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["指派D", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [
      "emergencyMeasure",
      "emergencyMeasureFileList",
    ],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  // 措施审批 (质量改善部B -> 质量改善部D)
  Activity_03xvm5q: {
    taskName: "措施审批",
    recordName: "审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["填写Tab资料", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [
      "emergencyMeasure",
      "emergencyMeasureFileList",
    ],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  // 措施审批 (质量改善部D -> 质量改善部B)
  Activity_1wd468a: {
    taskName: "措施审批",
    recordName: "审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [
      "emergencyMeasure",
      "emergencyMeasureFileList",
    ],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  // 措施审批 (质量改善部B -> 质量改善部A)
  Activity_0ozajkb: {
    taskName: "措施审批",
    recordName: "审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [
      "emergencyMeasure",
      "emergencyMeasureFileList",
    ],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  // 措施审批 (质量改善部A -> 质量改善部C)
  Activity_1ljcp7e: {
    taskName: "措施审批",
    recordName: "审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  /*
   * 类型二，三公共节点
   */
  // 措施话术 (质量改善部C -> 技术经理)
  Activity_1sulfwd: {
    taskName: "措施话术",
    recordName: "措施话术",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: ["marketLanguage"],
    showEmergencyMeasureTabFormItem: [
      "emergencyMeasureShow",
      "marketLanguageShow",
    ],
  },
  /*
   * 类型一，二，三公共节点
   */
  // 优化措施话术（技术经理 -> OTS部长或技术专家）
  Activity_07czbgn: {
    taskName: "优化措施话术",
    recordName: "优化措施话术",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: ["marketLanguage"],
    showEmergencyMeasureTabFormItem: [
      "emergencyMeasureShow",
      "marketLanguageShow",
    ],
  },
  // 措施审批（OTS部长或技术专家 -> 服务经理）
  Activity_1m3u00z: {
    taskName: "措施审批",
    recordName: "措施审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: ["marketLanguageShow"],
  },
  // 措施审批（服务经理 -> 地总）
  Activity_1h8leq4: {
    taskName: "措施审批",
    recordName: "措施审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: ["marketLanguageShow"],
  },
  // 措施确认（地总 -> 服务经理）
  Activity_0627lvf: {
    taskName: "措施确认",
    recordName: "措施确认",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["竞争通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: ["marketLanguageShow"],
  },
  // 措施验证（服务经理 -> 服务经理）
  Activity_1kbk3hf: {
    taskName: "措施验证",
    recordName: "措施验证",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["填写验证说明", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: ["marketLanguageShow"],
  },
  /*
   * 类型三节点
   */
  // 应急措施 (质量改善部A -> 质量改善部B)
  Activity_1ifjtsi: {
    taskName: "应急措施",
    recordName: "应急措施",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      // { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["指派D", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [
      "emergencyMeasure",
      "emergencyMeasureFileList",
    ],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  // 措施审批 (质量改善部B -> 质量改善部A)
  Activity_0la3cgt: {
    taskName: "措施审批",
    recordName: "措施审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [
      "emergencyMeasure",
      "emergencyMeasureFileList",
    ],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  // 措施审批 (质量改善部A -> 质量改善部C)
  Activity_16j4rta: {
    taskName: "措施审批",
    recordName: "措施审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  // 措施审批 (质量改善部D -> 质量改善部B)
  Activity_1ege4f8: {
    taskName: "应急措施",
    recordName: "应急措施",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["填写应急措施","填写Tab资料", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [
      "emergencyMeasure",
      "emergencyMeasureFileList",
    ],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  // 措施审批 (质量改善部B -> 质量改善部A)
  Activity_1bx8fmk: {
    taskName: "应急措施",
    recordName: "应急措施",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      // { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [
      "emergencyMeasure",
      "emergencyMeasureFileList",
    ],
    showEmergencyMeasureTabFormItem: ["emergencyMeasureShow"],
  },
  // 根因分析 B->D
  Activity_139gu3b: {
    taskName: "根因分析",
    recordName: "根因分析",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "根因分析", name: "rootCauseAnalysisTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["指派D", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledRootCauseAnalysisTab: true,
    enableRootCauseAnalysisTabFormItem: [
      "isLoseCauseAnalysis",
      "causeAnalysisLose",
      // "causeAnalysis",
    ],
    showRootCauseAnalysisTabFormItem: [
      "isLoseCauseAnalysis",
      "causeAnalysisLose",
      // "causeAnalysis",
      "causeAnalysisFileList",
    ],
  },
  // 根因分析：上一节点B 当前节点D质量改善部D判断是否差缺根因分析材料
  Activity_0n9m3yo:{
    taskName: "根因分析",
    recordName: "根因分析",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "根因分析", name: "rootCauseAnalysisTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["填写Tab资料", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledRootCauseAnalysisTab: true,
    enableRootCauseAnalysisTabFormItem: [
      "isLoseCauseAnalysis",
      "causeAnalysisLose",
      "causeAnalysis",
    ],
    showRootCauseAnalysisTabFormItem: [
      "isLoseCauseAnalysis",
      "causeAnalysisLose",
      "causeAnalysis",
      "causeAnalysisFileList",
    ],
  },
  // 根因分析- 上一节点D 当前节点B
  Activity_1xs1egl: {
    taskName: "根因分析",
    recordName: "根因分析",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "根因分析", name: "rootCauseAnalysisTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledRootCauseAnalysisTab: true,
    enableRootCauseAnalysisTabFormItem: [
      "isLoseCauseAnalysis",
      "causeAnalysisLose",
      "causeAnalysis",
    ],
    showRootCauseAnalysisTabFormItem: [
      "isLoseCauseAnalysis",
      "causeAnalysisLose",
      "causeAnalysis",
      "causeAnalysisFileList",
    ],
  },
  // 根因分析-上传材料 (质量改善部B -> 服务经理)
  Activity_0a0691e: {
    taskName: "根因分析-上传材料",
    recordName: "根因分析-上传材料",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "根因分析", name: "rootCauseAnalysisTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledRootCauseAnalysisTab: true,
    enableRootCauseAnalysisTabFormItem: ["causeAnalysisFileList"],
    showRootCauseAnalysisTabFormItem: [
      "causeAnalysisLose",
      "causeAnalysisFileList",
    ],
  },
  // 根因分析-审批 (质量改善部B -> 质量改善部A)
  Activity_05ou00x: {
    taskName: "根因分析-审批",
    recordName: "根因分析-审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "根因分析", name: "rootCauseAnalysisTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledRootCauseAnalysisTab: true,
    enableRootCauseAnalysisTabFormItem: ["causeAnalysis"],
    showRootCauseAnalysisTabFormItem: [
      "causeAnalysis",
      "causeAnalysisFileList",
    ],
  },
  // 根因分析-审批 (质量改善部A -> 质量改善部C)
  Activity_193ui3v: {
    taskName: "根因分析-审批",
    recordName: "根因分析-审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "根因分析", name: "rootCauseAnalysisTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledRootCauseAnalysisTab: true,
    enableRootCauseAnalysisTabFormItem: [],
    showRootCauseAnalysisTabFormItem: [
      "causeAnalysis",
      "causeAnalysisFileList",
    ],
  },
  // 根因分析-审批 (质量改善部C -> 技术经理)
  Activity_0fqlwpd: {
    taskName: "根因分析-审批",
    recordName: "根因分析-审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "根因分析", name: "rootCauseAnalysisTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledRootCauseAnalysisTab: true,
    enableRootCauseAnalysisTabFormItem: [],
    showRootCauseAnalysisTabFormItem: [
      "causeAnalysis",
      "causeAnalysisFileList",
    ],
  },
  // 根因分析-审批 (技术经理 -> 技术专家)
  Activity_1i98y04: {
    taskName: "根因分析-审批",
    recordName: "根因分析-审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "根因分析", name: "rootCauseAnalysisTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledRootCauseAnalysisTab: true,
    enableRootCauseAnalysisTabFormItem: [],
    showRootCauseAnalysisTabFormItem: [
      "causeAnalysis",
      "causeAnalysisFileList",
    ],
  },
  // 永久方案 ( 质量改善部B-> 质量改善部D )
  Activity_0e11xol: {
    taskName: "永久方案",
    recordName: "永久方案",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["指派D", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [
      "permanentPlan",
      "permanentPlanFileList",
    ],
    showPermanentProjectTabFormItem: [],
  },
  // 永久方案 (质量改善部D -> 质量改善部B)
  Activity_0gf6t7g: {
    taskName: "永久方案",
    recordName: "永久方案",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["填写Tab资料", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [
      "permanentPlan",
      "permanentPlanFileList",
    ],
    showPermanentProjectTabFormItem: ["permanentPlan"],
  },
  // 永久方案 (质量改善部B -> 质量改善部A)
  Activity_0mraaga: {
    taskName: "永久方案",
    recordName: "永久方案",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      // { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [
      "permanentPlan",
      "permanentPlanFileList",
    ],
    showPermanentProjectTabFormItem: ["permanentPlan"],
  },
  // 永久方案-审批 (质量改善部B -> 质量改善部A)
  Activity_1mpgwjo: {
    taskName: "永久方案-审批",
    recordName: "永久方案-审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [
      "permanentPlan",
      "permanentPlanFileList",
    ],
    showPermanentProjectTabFormItem: ["permanentPlan"],
  },
  // 永久方案-审批 (质量改善部A -> 质量改善部C)
  Activity_0x5zyud: {
    taskName: "永久方案-审批",
    recordName: "永久方案-审批",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [],
    showPermanentProjectTabFormItem: ["permanentPlan"],
  },
  // 永久方案-填写市场话术 (质量改善部C -> 技术经理)
  Activity_1bumh50: {
    taskName: "永久方案-填写市场话术",
    recordName: "永久方案-填写市场话术",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: ["permanentPlanLanguage"],
    showPermanentProjectTabFormItem: ["permanentPlan", "permanentPlanLanguage"],
  },
  // 永久方案-优化市场话术 (技术经理 -> 技术专家)
  Activity_1qfcij8: {
    taskName: "永久方案-优化市场话术",
    recordName: "永久方案-优化市场话术",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: ["permanentPlanLanguage"],
    showPermanentProjectTabFormItem: ["permanentPlan", "permanentPlanLanguage"],
  },
  // 永久方案-上传巡检记录 (技术专家 -> 技术经理)
  Activity_0p8zwt0: {
    taskName: "永久方案-上传巡检记录",
    recordName: "永久方案-上传巡检记录",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["上传巡检记录", "验证通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [],
    showPermanentProjectTabFormItem: [
      "permanentPlan",
      "permanentPlanLanguage",
      "inspectRecord",
    ],
  },
  // 永久方案-关闭,同步市场 (技术经理 -> 技术经理)
  Activity_068dwsq: {
    taskName: "永久方案-关闭,同步市场",
    recordName: "永久方案-关闭,同步市场",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["永久方案通过", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [],
    showPermanentProjectTabFormItem: [
      "permanentPlan",
      "permanentPlanLanguage",
      "inspectRecord",
    ],
  },
  // 永久方案-市场验证 (技术经理 -> 服务经理)
  Activity_15dcx2n: {
    taskName: "永久方案-市场验证",
    recordName: "永久方案-市场验证",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["填写市场验证说明", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [],
    showPermanentProjectTabFormItem: ["permanentPlanLanguage", "inspectRecord"],
  },
  // 永久方案-市场关闭 (服务经理 -> 服务经理)
  Activity_0fsewki: {
    taskName: "永久方案-市场关闭",
    recordName: "永久方案-市场关闭",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["永久方案通过2", "驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [],
    showPermanentProjectTabFormItem: ["permanentPlanLanguage", "inspectRecord"],
  },
  // 类型三问题关闭
  Activity_0gzncmb: {
    taskName: "问题关闭",
    recordName: "问题关闭",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["关闭", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: ["marketLanguageShow"],
  },
  // 展示所有页签详情
  allDetail: {
    taskName: "",
    recordName: "",
    tabList: [
      { label: "问题详情", name: "problemDetailTab" },
      { label: "应急措施", name: "emergencyMeasureTab" },
      { label: "根因分析", name: "rootCauseAnalysisTab" },
      { label: "永久方案", name: "permanentProjectTab" },
      { label: "处理信息", name: "dealInfoTab" },
    ],
    operate: ["驳回", "返回列表"],
    disabledProblemDetailTab: true,
    enableProblemDetailTabFormItem: [],
    disabledEmergencyMeasureTab: true,
    enableEmergencyMeasureTabFormItem: [],
    showEmergencyMeasureTabFormItem: ["marketLanguageShow"],
    disabledRootCauseAnalysisTab: true,
    enableRootCauseAnalysisTabFormItem: [],
    showRootCauseAnalysisTabFormItem: [
      "causeAnalysis",
      "causeAnalysisFileList",
    ],
    disabledPermanentProjectTab: true,
    enablePermanentProjectTabFormItem: [],
    showPermanentProjectTabFormItem: ["permanentPlanLanguage", "inspectRecord"],
  },
};
